import { Box, SimpleGrid, Text } from '@chakra-ui/react';
import {
  PlusIcon,
  Squares2X2Icon,
  CalendarDaysIcon,
  RectangleStackIcon,
  MagnifyingGlassIcon,
  ShareIcon,
} from '@heroicons/react/24/outline';
import QuickActionTile from './quick-action-tile';

type Props = {
  onCreateContent?: () => void;
  onBuildCollection?: () => void;
  onBuildPlan?: () => void;
  onBrowseContent: () => void;
  onFindContent: () => void;
  onShareContent: () => void;
};

export default function QuickActions({
  onCreateContent,
  onBuildCollection,
  onBuildPlan,
  onBrowseContent,
  onFindContent,
  onShareContent,
}: Props) {
  return (
    <Box mb={8}>
      <Text textStyle='eyebrow' mb={3}>
        Quick actions
      </Text>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap={3}>
        {onCreateContent && (
          <QuickActionTile
            icon={PlusIcon}
            title='Create content'
            description='A drill, play, skill, tactic…'
            iconBg='slot3.bg'
            iconColor='slot3.fg'
            onClick={onCreateContent}
          />
        )}
        {onBuildCollection && (
          <QuickActionTile
            icon={Squares2X2Icon}
            title='Build a collection'
            description='Assemble a playbook or plan'
            iconBg='slot4.bg'
            iconColor='slot4.fg'
            onClick={onBuildCollection}
          />
        )}
        {onBuildPlan && (
          <QuickActionTile
            icon={CalendarDaysIcon}
            title='Build a plan'
            description='Draft a practice for today'
            iconBg='slot6.bg'
            iconColor='slot6.fg'
            onClick={onBuildPlan}
          />
        )}
        <QuickActionTile
          icon={RectangleStackIcon}
          title='Browse content'
          description='Jump into a library'
          iconBg='slot1.bg'
          iconColor='slot1.fg'
          onClick={onBrowseContent}
        />
        <QuickActionTile
          icon={MagnifyingGlassIcon}
          title='Find content'
          description='Search across everything'
          iconBg='slot2.bg'
          iconColor='slot2.fg'
          onClick={onFindContent}
        />
        <QuickActionTile
          icon={ShareIcon}
          title='Share content'
          description='Send a link or print a copy'
          iconBg='slot5.bg'
          iconColor='slot5.fg'
          onClick={onShareContent}
        />
      </SimpleGrid>
    </Box>
  );
}
